// @flow

import * as React from "react";
import { useSelector } from "react-redux";
import Button from "../atoms/Button";
import Icon from "../atoms/Icon";

type PropsType = {};

const ShopFooter = (props: PropsType): React.Node => {
    const { delivery_information, help } = useSelector(
        (state: any): any => state.options
    );
    const baseClassName = "shop-footer";
    const classes = [baseClassName];

    return (
        <div className={classes.join(" ")}>
            <div className="container-fluid">
                <div className="row row--padding-small">
                    {delivery_information ? (
                        <div className="col-xs-12 col-sm-6">
                            <ShopFooterItem
                                icon="truck"
                                title={delivery_information.title}
                                description={delivery_information.description}
                                ctas={delivery_information.ctas}
                            />
                        </div>
                    ) : null}
                    {help ? (
                        <div className="col-xs-12 col-sm-6">
                            <ShopFooterItem
                                icon="help"
                                title={help.title}
                                description={help.description}
                                ctas={help.ctas}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

ShopFooter.defaultProps = {};

const ShopFooterItem = (props: {}): React.Node => {
    const baseClassName = "shop-footer__item";
    const classes = [baseClassName];

    return (
        <div className={classes.join(" ")}>
            <Icon className="shop-footer__item__icon" name={props.icon} />
            <div className="shop-footer__item__title">{props.title}</div>
            <div className="shop-footer__item__description">
                {props.description}
            </div>
            <div className="shop-footer__item__ctas">
                {props.ctas.map((cta, index) => {
                    return (
                        <Button
                            key={index}
                            to={cta.cta.url}
                            inline={true}
                            small={true}
                            styles={["simple"]}
                        >
                            {cta.cta.title}
                        </Button>
                    );
                })}
            </div>
        </div>
    );
};

export default ShopFooter;
